import { addDays, format, parseISO, startOfWeek } from "date-fns";

/**
 * Week/date helpers shared by the Programming plan views (nutrition, workout).
 * The plan APIs key everything by `yyyy-MM-dd` strings and weeks start on
 * Monday, exactly as the mobile app does with luxon. All functions take and
 * return ISO date strings so callers never hold a `Date`.
 */

const ISO_DATE = "yyyy-MM-dd";

export const parseISODate = (iso: string): Date => parseISO(iso);

export const toISODate = (date: Date): string => format(date, ISO_DATE);

/** Today's date in the browser's local timezone (not UTC). */
export const todayISO = (): string => toISODate(new Date());

export const addDaysISO = (iso: string, days: number): string =>
  toISODate(addDays(parseISODate(iso), days));

/** The Monday of the week containing `iso`. */
export const mondayOf = (iso: string): string =>
  toISODate(startOfWeek(parseISODate(iso), { weekStartsOn: 1 }));

export const thisWeekMonday = (): string => mondayOf(todayISO());

/**
 * "Oct 5 – Oct 11, 2026" for the week starting on `mondayIso` — the same
 * wording the History › Timeline navigator uses for a week.
 */
export const formatWeekLabel = (mondayIso: string): string => {
  const start = parseISODate(mondayIso);
  return `${format(start, "MMM d")} – ${format(addDays(start, 6), "MMM d, yyyy")}`;
};

/** "2026-10-26T18:30:00" → "2026-10-26". Returns "" for empty input. */
export const dateOfISO = (iso: string | undefined | null): string =>
  iso ? iso.slice(0, 10) : "";
